import { render, staticRenderFns } from "./2022_618.vue?vue&type=template&id=7444afdf&scoped=true&"
import script from "./2022_618.vue?vue&type=script&lang=js&"
export * from "./2022_618.vue?vue&type=script&lang=js&"
import style0 from "./2022_618.vue?vue&type=style&index=0&id=7444afdf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7444afdf",
  null
  
)

export default component.exports